import { AppShellBanner } from "@sylviq/ui-react-web/components/shell/AppShellTopInset";

const fullStackMode = import.meta.env.VITE_NICHE_TEST_MODE === "fullstack";

export function DevModeBanner() {
  if (!fullStackMode) return null;

  return (
    <AppShellBanner>
      <span>
        Local full-stack mode — sign-up, sessions, and data stay on this
        machine.
      </span>
      <a className="underline underline-offset-2" href="/__dev/mailbox">
        Open local email inbox
      </a>
    </AppShellBanner>
  );
}
